import React from "react";

export default function Footer() {
  return (
    <footer className="bg-indigo-600 text-white py-6">
      <div className="container mx-auto text-center">
        <p className="text-sm">
          Copyright © All rights reserved | <span className="font-bold">IMMUNOCON 2025</span>
        </p>
        <p className="text-sm mt-2">
        Designed and Developed by team
        <a href="/web-team"><span className="font-medium"> Henix Rehab</span></a>
        </p>
      </div>
    </footer>
  );
}